<template>
  <div>
    <div
      class="book"
      :style="{ 'background-color': bgc }"
      :class="{ startBtn: bgc !== '#242B2A' }"
      @click="submitShow = true"
    >
      {{ $t(`${text}`) }}
    </div>
    <mobilePublicConsultation
      v-if="submitShow"
      @close="submitShow = false"
    ></mobilePublicConsultation>
  </div>
</template>

<script>
export default {
  props: {
    bgc: {
      type: String,
      default: '#242B2A'
    },
    text: {
      type: String,
      default: 'startForFree'
    }
  },
  data () {
    return {
      submitShow: false
    }
  }
}
</script>

<style scoped lang="less">
.startBtn {
  padding: 0.266667rem /* 10/37.5 */ !important;
  color: #ffffff;
  font-size: 0.32rem !important;
  display: inline-block;
  max-width: 3.2rem /* 120/37.5 */;
  text-align: center;
}
.book {
  margin: 0.4rem 0;
  padding: 0.28rem 0.72rem;
  border-radius: 0.64rem;
  color: #ffffff;
  font-size: 0.4rem;
  font-weight: bold;
  display: inline-block;
}
</style>
